<template>
    <div class="continer">
        <background>
            <div v-if="!scanFinish">
                <div class="content">
                    <div class="tips">
                        <div>如图示</div>
                        <div>将凭证分隔页放入扫描区域完成扫描</div>
                    </div>
                    <div class="img">
                        <img src="@/assets/images/busImage/separatePage.gif" style="width:100%;height:100%"/>
                    </div>
                    <div class="scan-btn" @click="startScan">开 始 扫 描</div>
                </div>
            </div>
            <div v-else>
                <div class="result">
                    <div v-if="scanFinish && !warehousingFinish">
                        <div class="result-info" >
                            <img src="@/assets/images/busImage/confirm.png">
                            <span>扫描完成，凭证入库中，请稍后...</span>
                        </div>
                    </div>
                    <div v-if="result.status === 1">
                        <div class="result-info" v-if="scanFinish && warehousingFinish">
                            <img src="@/assets/images/busImage/confirm.png">
                            <span>凭证已入库</span>
                        </div>
                    </div>
                    <div v-if="result.status === 2">
                        <div class="result-info-error">
                            <img src="@/assets/images/busImage/fail.png">
                            <span>制单失败</span>
                        </div>
                    </div>
                </div>
                <div v-if="result.status" class="next-btn"  @click="makeOrder">继续制单</div>
            </div>
        </background>
        <pageHeader ref="pageHeader" isCustom>
            <div class="logout-btn" v-if="warehousingFinish" @click="logout">退出登录</div>
            <div class="logout-btn" v-if="!scanFinish" @click="goBack">返回上一步</div>
        </pageHeader>
        <tipsDialog tipsMessage="扫描中，请稍等..."
                     :dialogVisible="scanLoadingDialogVisible">
        </tipsDialog>
        <tipsDialog tipsMessage="等待扫描仪复位中，请稍等..."
                    :dialogVisible="waitScannerLocationDialogVisible">
        </tipsDialog>
        <tipsDialog tipsMessage="由于长时间未扫描凭证分隔页，此单即将自动结束，请取出退回的原始凭证"
                     :dialogVisible="noScanVoucheDialogVisible">
                    <div class="btn-group">
                        <div class="cancle-btn" @click="overMakeOrder">立即结束</div>
                        <div class="confirm-btn" @click="continueOperation">继续操作</div>
                    </div>
        </tipsDialog>
        <tipsDialog tipsMessage="扫描仪入口处无纸，或纸张放置不正确，请处理后再扫描"
                     :dialogVisible="noPaperDialogVisible">
                    <div class="text-btn" @click="closeNoPaperDialog">已处理</div>
        </tipsDialog>
        <tipsDialog tipsMessage="扫描仪盖未关闭，请处理后再扫描"
                     :dialogVisible="openlidDialogVisible">
                    <div class="text-btn" @click="closeOpenlidDialog">已处理</div>
        </tipsDialog>
        <tipsDialog tipsMessage="出现卡纸，清除卡纸后请将扫描仪推回设备内，并取出已扫描的原始凭证"
                     :dialogVisible="paperJamDialogVisible">
                     <div class="text-btn" @click="openScanner">打开扫描仪</div>
        </tipsDialog>
        <tipsDialog tipsMessage="凭证分隔页错误，请取走托盘中全部纸张，若有需要，请重新制证"
                     :dialogVisible="voucherErrorDialogVisible">
                     <div class="text-btn" @click="openDish">打开托盘</div>
        </tipsDialog>
        <tipsDialog tipsMessage="请点击打开托盘，取出原始凭证"
                     :dialogVisible="ejectFileDialogVisible">
                     <div class="text-btn" @click="openDish">打开托盘</div>
        </tipsDialog>
        <exitTicketProcess ref="exitTicketProcess" exitTitle="取出全部原始凭证后，请点击收回托盘" @dishHandleFinish="dishHandleFinish"></exitTicketProcess>
        <errorDialog :errorMessage="errorMessage" :dialogVisible="errorDialogVisible"></errorDialog>
        <el-dialog
            :visible.sync="dialogVisible"
            width="800px"
            top="40vh"
            :show-close="false">
            <div class="confirm-content">
                <div class="info">
                    <img src="@/assets/images/busImage/warning.png"/>
                    <div class="tips">入库成功，纸仓已满，无法继续制单，将在<span>{{countDownNum}}</span>秒后退出登录</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import background from '@/components/background'
import pageHeader from '@/components/pageHeader'
import errorDialog from '@/components/errorDialog'
import tipsDialog from '@/components/tipsDialog'
import exitTicketProcess from '@/components/exitTicketProcess'

import { getToken, getCookie } from "@/utils/auth";
import axios from "axios";
import { downloadVoucher } from '@/api/order'
import paperDishMixin from '@/mixin/paperDishMixin'
import scanMixin from '@/mixin/scanMixin'
import {uploadLogs} from '@/api/user'
export default {
    components: {
        background,
        pageHeader,
        errorDialog,
        tipsDialog,
        exitTicketProcess
    },
    mixins: [paperDishMixin,scanMixin],
    data(){
        return {
            imageList:[], // 扫描图片列表
            fileIds:[],
            result: {
                status: 0 // 0: 未开始 1： 成功 2：失败
            },
            handlePrintFinishTimer: null, // 打印完成后的记时处理
            scanFinish: false, // 是否扫描完成
            warehousingFinish: false,
            // ---弹框----
            ejectFileDialogVisible: false,
            scanLoadingDialogVisible: false,
            noScanVoucheDialogVisible: false, // 60s未扫回
            voucherErrorDialogVisible: false, // 凭证错误
            noPaperDialogVisible: false,
            paperJamDialogVisible: false,
            openlidDialogVisible: false,
            waitScannerLocationDialogVisible: false, // 等待扫描仪复位loading
            dialogVisible: false,
            countDownNum: 15,
            // 未知错误
            errorMessage: '',
            errorDialogVisible: false
        }
    },
    computed: {
        id(){
            return this.$route.query.id || 0
        },
        orgId() {
            if(getCookie('orgInfo')){
                return +(JSON.parse(getCookie('orgInfo')).id)
            }else {
                return 0
            }
        }
    },
    mounted(){
        this.handlePrintCountDown()
    },
    destroyed(){
        this.ist.removeEventListener("onScanPage", this.onScanPageComplete);
        clearTimeout(this.handlePrintFinishTimer)
    },
    methods: {
        closeNoPaperDialog(){
            this.noPaperDialogVisible = false
            this.ist.removeEventListener("onScanPage", this.onScanPageComplete);
        },
        closeOpenlidDialog(){
            this.openlidDialogVisible = false
        },
        // 打印凭证后的倒计时处理
        handlePrintCountDown(){
            this.handlePrintFinishTimer = setTimeout(() => {
                clearTimeout(this.handlePrintFinishTimer)
                this.noScanVoucheDialogVisible = true
            }, 60*1000)
        },
        continueOperation(){
            this.noScanVoucheDialogVisible = false
            this.handlePrintFinishTimer = setTimeout(() => {
                clearTimeout(this.handlePrintFinishTimer)
                this.noScanVoucheDialogVisible = true
            }, 2 * 60*1000)
        },
        overMakeOrder(){
            this.noScanVoucheDialogVisible = false
            this.$refs.pageHeader.continueCancle()
        },
        startScan(){
            this.ist.addEventListener("onScanPage", this.onScanPageComplete);
            this.scanLoadingDialogVisible = true
            clearTimeout(this.handlePrintFinishTimer)
            this.scan().then(res => {
                // 扫描完成
                this.scanLoadingDialogVisible = false
                this.scanFinish = true
                this.handleSaveVoucher()
            }).catch(e => {
                this.scanLoadingDialogVisible = false
                if(e.status === 1){
                    this.noPaperDialogVisible = true
                }else if(e.status === 2){
                    this.paperJamDialogVisible = true
                }else if (e.status === 3){
                    this.openlidDialogVisible = true
                }
            })
        },
        handleSaveVoucher() {
            const base64ToBlob = (base64) => {
                let arr = base64.split(',');
                let mime = arr[0].match(/:(.*?);/)[1];
                let bstr = atob(arr[1]);
                let n = bstr.length;
                let u8arr = new Uint8Array(n);
                while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            };
            const formData = new FormData();
            this.imageList.forEach(item => {
                let blob = base64ToBlob(item.base64);
                formData.append('files', blob); 
            })
            formData.append('orgId', this.orgId)
            formData.append('id', this.id)
            let baseUrl = process.env.NODE_ENV === "production" ? process.env.VUE_APP_BASE_API : '/api'
            let url = baseUrl + "/accountingInformation/saveVoucher"
            axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization' : "Bearer " + getToken()
                    }
                })
                .then(res => {
                    localStorage.removeItem('imgShowList')
                    localStorage.removeItem('blankImageList')
                    if(res.data.code === 200){
                        this.retain().then(res => {
                            this.result.status = 1
                            this.warehousingFinish = true
                        }).catch(e => {
                            if(e.status === -11){
                                this.result.status = 1
                                this.warehousingFinish = true
                                this.dialogVisible = true
                                this.handleCountDown()
                            }
                        })
                    }else {
                        this.voucherErrorDialogVisible = true
                    }
                    
                })
                .catch(error => {
                    this.isFinish = true
                    this.result.status = 2
                    localStorage.removeItem('imgShowList')
                    localStorage.removeItem('blankImageList')
                });
        }, 
        makeOrder(){
            this.$router.push({name: 'start'})
        },
        logout(){
            uploadLogs({
                content: '按钮触发，主动退出',
                errorCode: 0,
                module: '退出登录'
            }).catch(e => {})
            this.$store.dispatch('LogOut').then(() => {
                this.$router.push({name: 'login'})
            })
        },
        goBack(){
            this.$router.go(-1)
        },       
         // 纸仓满退出登录流程
        handleCountDown(){
            let remainingSeconds = 15;
            this.countDownNum = remainingSeconds
            let that =  this
            this.timerId = setInterval(function() {
                if (remainingSeconds === 0) {
                    clearInterval(that.timerId);
                    that.dialogVisible = false
                    that.$store.dispatch('LogOut').then(() => {
                        that.$router.push({name: 'login',query:{status: 11}})
                    })
                } else {
                    that.countDownNum = remainingSeconds
                    remainingSeconds--;
                }
            }, 1000);
        },
        // 扫描一张回调
        async onScanPageComplete(params){
            console.log("onScanPage扫描完一张:" + JSON.stringify(params));
            // 正面图
            let frontImgBase64 = {};
            frontImgBase64.imgIndex = new Date().getTime() + '0';
            let frontBase64 = await this.readFileAsBase64(params.front_image);
            frontImgBase64.base64 = 'data:image/jpeg;base64,' + frontBase64;
            this.imageList.push(frontImgBase64)
            // 反面图
            let backImgBase64 = {};
            backImgBase64.imgIndex = new Date().getTime() + '1';
            let backBase64 = await this.readFileAsBase64(params.back_image);
            backImgBase64.base64 = 'data:image/jpeg;base64,' + backBase64;
            this.imageList.push(backImgBase64)
        },
        // 弹出扫描仪
        openScanner(){
            this.unlockScanner().then(res => {
                this.paperJamDialogVisible = false
            })
        },
        // 弹出托盘
        openDish(){
            this.ejectFileDialogVisible = false
            this.$refs.exitTicketProcess.getDishHavePaper()
        },
        dishHandleFinish(){
            this.imageList = []
        }
    }
}
</script>
<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    .content {
        position: absolute;
        top: 233px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        .tips {
            font-weight: 400;
            font-size: 32px;
            color: #000000;
            letter-spacing: 2px;
            text-align: center;
        }
        .img{
            width: 456px;
            height: 456px;
            margin: 40px 0;
            background: #FAFAFA;
            border-radius: 8px;
            border: 2px solid rgba(0,0,0,0.06);
        }
        .scan-btn {
            width: 456px;
            height: 80px;
            line-height:80px;
            background: radial-gradient( 0% 141% at -1% 0%, #C62D2F 0%, #B23B34 100%);
            border-radius: 8px;
            font-weight: 400;
            font-size: 28px;
            text-align: center;
            color: #FFFFFF;
        }
    }
    .print-btn {
        position: absolute;
        top: 170px;
        right: 40px;
        padding: 12px 32px;
        background: linear-gradient( 135deg, #C62D2F 0%, #B23B34 100%);
        border-radius: 8px;
        font-size: 24px;
        color: #FFFFFF;
    }
    .result {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%,-50%);
        text-align: center;
        &-info {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            font-weight: bold;
            img {
                margin-top: 8px;
            }
        }
        &-info-error {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            font-weight: bold;
            img {
                margin-right: 20px;
            }
        }
        .tips {
            font-size: 20px;
            margin-top: 30px;
            span {
                color: #B63933;
                margin-right: 10px;
            }
        }
    }
    .next-btn {
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translate(-50%,-50%);
        padding: 20px 153px;
        box-sizing: border-box;
        background: radial-gradient( 0% 141% at -1% 0%, #C62D2F 0%, #B23B34 100%);
        border-radius: 8px;
        font-weight: 400;
        font-size: 28px;
        color: #FFFFFF;
    }
    .logout-btn {
            position: absolute;
            padding: 17px 22px;
            top: 42px;
            right: 40px;
            background: rgba(239,239,239,0.5);
            border-radius: 8px;
            font-size: 32px;
            text-align: center;
            color: #FFFFFF;
    }
    .confirm-content {
        .info {
            display: flex;
            flex-direction: row;
            justify-content: center;
            img {
                width: 44px;
                height: 44px;
            }
            .tips {
                margin-left: 12px;
                margin-top: 5px;
                font-weight: 500;
                font-size: 32px;
                color: rgba(0,0,0,0.85);
                span{
                    margin: 0 5px;
                    color: #BE5852;
                }
            }
        }
        
    }
    /deep/ .el-dialog__header {
        padding: 0;
    }
</style>


